import React from "react";
import moment from "moment";

import MediaContentViewer from "../MediaContentViewer";

import "./index.css";

const ContentView = ({
  title,
  time,
  publishState,
  mediaUrl,
  mediaType,
  contentType,
  onEdit,
  onPublish,
  onUnpublish,
}) => {
  return (
    <div className="content-view-container">
      <div className="content-media">
        <MediaContentViewer media_url={mediaUrl} media_type={mediaType} />
      </div>
      <div className="content-info">
        <p className="content-title">{title}</p>
        <p className="content-time">{`Posted at ${moment(time).format(
          "MMMM DD, YYYY hh:mm A"
        )}`}</p>
        <p className="content-type">{contentType}</p>
        {publishState ? (
          <p className="state-live">Live</p>
        ) : (
          <p className="state-pending">Pending final publish</p>
        )}
      </div>
      <div className="content-actions">
        <button className="btn btn-white content-action-edit" onClick={onEdit}>
          Edit
        </button>
        <button
          className="btn btn-white content-action-publish"
          onClick={onPublish}
        >
          Publish
        </button>
        <button
          className="btn btn-white content-action-unpublish"
          onClick={onUnpublish}
        >
          Unpublish
        </button>
      </div>
    </div>
  );
};

export default ContentView;



// WEBPACK FOOTER //
// ./src/components/ContentView/index.jsx